import React from "react";
import searchIcon from "./styles/img/search.svg";
import styles from "./styles/AssetsFilter.module.css";

function AssetsFilter({ setFilter, placeholder }) {
  return (
    <form className={styles.search_form}>
      <div className={styles.search_field}>
        <button
          className={styles.search_button}
          type="submit"
          style={{ backgroundImage: `url(${searchIcon})` }}
        ></button>
        <input
          onChange={(e) => setFilter(e.target.value)}
          className={styles.search_input}
          type="search"
          name="search"
          placeholder={placeholder}
        />
      </div>
    </form>
  );
}

export default AssetsFilter;
